import { render, staticRenderFns } from "./oilCost.vue?vue&type=template&id=515e08cf&scoped=true&"
import script from "./oilCost.vue?vue&type=script&lang=js&"
export * from "./oilCost.vue?vue&type=script&lang=js&"
import style0 from "./oilCost.vue?vue&type=style&index=0&id=515e08cf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515e08cf",
  null
  
)

export default component.exports